import { writable } from '../external_node_modules/svelte/store/index.mjs.js';

const purchaseTwoFactor = {
    isTwoFactor: false,
    isThreeDS: false,
    method: null,
    code: null,
    threeDSRedirectUrl: null,
    validationErrorCode: null,
    isVisibleConfirmPurchasePopup: false,
};
const { subscribe, update } = writable(purchaseTwoFactor);
function setTwoFactorValidation(enabled) {
    return update((state) => {
        state.isTwoFactor = enabled;
        state.isThreeDS = !enabled;
        return state;
    });
}
function setThreeDSValidation(enabled) {
    return update((state) => {
        state.isThreeDS = enabled;
        state.isTwoFactor = !enabled;
        return state;
    });
}
function setSecureCode(code) {
    return update((state) => {
        state.code = code;
        return state;
    });
}
function setMethod(method) {
    return update((state) => {
        state.method = method;
        return state;
    });
}
function setThreeDSRedirectUrl(threeDSRedirectUrl) {
    return update((state) => {
        state.threeDSRedirectUrl = threeDSRedirectUrl;
        return state;
    });
}
function setValidationErrorCode(validationErrorCode) {
    return update((state) => {
        state.validationErrorCode = validationErrorCode;
        return state;
    });
}
function toogleVisibilityConfirmPurchasePopup(visibility) {
    return update((state) => {
        state.isVisibleConfirmPurchasePopup = visibility;
        return state;
    });
}
var purchaseTwoFactor$1 = {
    subscribe,
};

export { purchaseTwoFactor$1 as default, setMethod, setSecureCode, setThreeDSRedirectUrl, setThreeDSValidation, setTwoFactorValidation, setValidationErrorCode, toogleVisibilityConfirmPurchasePopup };
//# sourceMappingURL=purchaseTwoFactor.js.map
